import { Spinner } from '@lamimed/pantheon';
import { useRouter } from 'next/router';

import { Product as ProductDTO } from 'models/Product';

import { useCategory } from 'hooks/useCategory';
import { useCitySelection } from 'hooks/useCitySelection';
import { useSWRGet } from 'hooks/useSWRGet';

import { AttendenceType } from 'utils/enums/attendenceType';
import { getAxiosError } from 'utils/getAxiosError';
import { sendToErrorTracking } from 'utils/sendToErrorTracking';

import { ModalCitySelection } from 'templates/Category/containers/ModalCitySelection';

import Slide from 'components/Slide';

import { usePrescriptionModal } from '../PrescriptionModal/hooks/usePrescriptionModal';

import { NoProducts } from './NoProducts';
import { ProductCard, ProductCardTarget } from './ProductCard';

import * as S from './styles';

interface Props {
  haveContentBelow?: boolean;
}

export const Products: React.FC<Props> = ({ haveContentBelow }) => {
  const router = useRouter();
  const categorySlug = router.query.category;

  const { selectedCity } = useCitySelection();
  const { categoryData, categoryError } = useCategory();
  const { setIsPrescriptionModalOpen } = usePrescriptionModal();

  const locationsQuery = `?locations=${selectedCity}`;

  const { data, error } = useSWRGet<ProductDTO[]>(
    `/category/${categorySlug}/products/${
      categoryData?.attendenceType === AttendenceType.home ? locationsQuery : ''
    }`,
  );

  if (error) {
    sendToErrorTracking({ error, where: 'Products', context: data });

    if (getAxiosError(error).response?.status !== 404) router.push('/500');
  }

  if (categoryError) {
    sendToErrorTracking({
      error: categoryError,
      where: 'Products - CategoryError',
      context: categoryData,
    });

    router.push('/500');
  }

  return (
    <S.SlideWrapper haveContentBelow={haveContentBelow}>
      {categoryData?.attendenceType === AttendenceType.home && (
        <ModalCitySelection editable />
      )}

      {!data && !error && (
        <S.SpinnerWrapper>
          <Spinner />
        </S.SpinnerWrapper>
      )}

      {data ? (
        <Slide>
          {categoryData?.slug === 'esami-test' && (
            <ProductCard
              key="send-prescription"
              image="https://dw2wqdtrqluy8.cloudfront.net/img-cards/salute-a-domicilio-esami-del-sangue-con-lista.jpg"
              title="Hai una lista di esami?"
              price="Prelievo a partire da €35"
              buttonText="Inviaci la lista"
              handleClick={() => setIsPrescriptionModalOpen(true)}
            />
          )}

          {categoryData?.slug === 'esami-test' && (
            <ProductCard
              key="lami-x"
              image="https://dw2wqdtrqluy8.cloudfront.net/img-cards/salute-online-lami-x.jpg"
              title="Lami-X - Scopri gli esami giusti per te"
              link="https://chats.landbot.io/v3/H-1160659-709XQXAQ6KQVMZMH/index.html"
              target={ProductCardTarget.blank}
            />
          )}

          {data?.map((item) => (
            <ProductCard
              key={`product-${item.slug}`}
              link={`/${router.query.category}/${item.slug}`}
              image={item.image}
              title={item.activityTitle}
              price={item.priceLabel}
            />
          ))}
        </Slide>
      ) : (
        <NoProducts category={categoryData} />
      )}
    </S.SlideWrapper>
  );
};
